<template>
  <div>
    <v-dialog v-model="dialog" persistent width="600">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" depressed rounded class="add-modal__btn">
          <v-icon color="#757575">mdi-plus</v-icon>
          {{ $t('add account') }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="d-flex justify-center">
          <h2>{{ $t('create account') }}</h2>
        </v-card-title>
        <v-card-text class="pt-5">
          <v-text-field v-model="accountData.name" :label="$t('account name')" outlined dense
            color="#757575"></v-text-field>
          <v-autocomplete :label="$t('parent account')" outlined dense v-model="accountData.parent" color="#757575"
            item-text="name" item-value="id" :loading="itemsLoading" :items="accountItems" return-object no-filter
            v-debounce="fetchAutoComplete"></v-autocomplete>
          <div class="d-flex justify-center align-center">
            <v-text-field v-model="accountData.serial" :label="$t('account code')" outlined dense color="#757575"
              :disabled="!accountData.parent"></v-text-field>
            <p class="pb-2">-{{ getParentSerial }}</p>
          </div>
          <v-text-field v-model="accountData.tax_registration_number" :label="$t('Tax Registration Number')" outlined dense
            color="#757575"></v-text-field>
          <!-- <v-autocomplete
            label="الحساب الختامي"
            outlined
            dense
            color="#757575"
            :items="types"
            v-model="accountData.type"
            hide-details
          >
          </v-autocomplete> -->
          <v-checkbox :dark="$store.state.isDarkMode" :label="$t('The account is cash')" dense v-model="accountData.cash" :true-value="1"
            :false-value="0" color="#757575"></v-checkbox>
          <div class="d-flex justify-space-between align-center mb-5">
            <h4>{{ $t('Account specifications') }}</h4>
            <v-icon class="account-specifications__add-icon" @click="newSpecification = true">mdi-plus-thick</v-icon>
          </div>
          <v-fade-transition group mode="out-in">
            <v-row v-for="(specification, index) in accountSpecifications" :key="index">
              <v-col md="3" class="py-0">
                <v-text-field outlined dense v-model="specification.key"></v-text-field>
              </v-col>
              <v-col md="7" class="py-0">
                <v-text-field outlined dense v-model="specification.value"></v-text-field>
              </v-col>
              <v-col md="2">
                <v-icon color="red" @click="deleteAttribute(index)">mdi-delete</v-icon>
              </v-col>
            </v-row>
          </v-fade-transition>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn :loading="submitAccountBtnLoading" depressed color="blue-grey" class="white--text"
            @click="addAccount">{{ $t('storage') }}</v-btn>
          <v-btn depressed color="primary" @click="clearData">{{ $t('cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Notifications from "../../../../../helpers/toast-notifications";
export default {
  data() {
    return {
      accountData: {
        name: "",
        parent: null,
        serial: null,
        // enum
        // checkbox
        cash: 0,
        editable: 1,
        hidden: 0,
        attributes: [],
        tax_registration_number: null,
      },
      parentSerial: null,
      // types: ["trading", "profits_and_losses", "balance"],
      newSpecification: false,
      dialog: false,
      itemsLoading: false,
      accountItems: [],
      accountSpecificationsArray: [],
      submitAccountBtnLoading: false,
    };
  },
  computed: {
    getParentSerial() {
      return (this.parentSerial = this.accountData.parent?.serial);
    },
    accountSpecifications() {
      if (this.newSpecification) {
        let accountSpecification = {
          key: "",
          value: "",
        };
        this.accountData.attributes.push(accountSpecification);
        this.newSpecification = false;
      }
      return this.accountData.attributes;
    },
  },

  methods: {
    clearData(){
      this.dialog = false;
      this.accountData = {
        name: "",
        parent: null,
        serial: null,
        // enum
        // checkbox
        cash: 0,
        editable: 1,
        hidden: 0,
        attributes: [],
        tax_registration_number: null,
      };
    },
    async addAccount() {
      try {
        this.submitAccountBtnLoading = true;
        await axios.post("/accounting/account", {
           ...this.accountData,
          parent_id: this.accountData.parent.id,
          serial: this.accountData.parent.serial + this.accountData.serial,
        });
        this.dialog = false;
        this.$emit("reFetchTree");
        Notifications(
          this.$t('add success'),
          { timeout: 2000, rtl: true },
          "success"
        );
      } catch (err) {
      } finally {
        this.submitAccountBtnLoading = false;
      }
    },
    deleteAttribute(index) {
      this.accountData.attributes.splice(index, 1);
    },
    async fetchAutoComplete(value) {
      try {
        if (!value) return;
        this.itemsLoading = true;
        const searchResult = await axios.get(
          "/accounting/folder/auto-complete",
          {
            params: {
              query: value,
            },
          }
        );
        this.accountItems = searchResult.data.data;
      } catch (err) {
      } finally {
        this.itemsLoading = false;
      }
    },
  },
};
</script>

<style>
.account-specifications__add-icon {
  color: #757575;
  border: 1px solid #757575;
  border-radius: 50%;
  padding: 3px;
}

.account-specifications__add-icon:hover {
  transform: scale(1.1);
}
</style>